import StoreSubscriptions from "@/models/loyaltyPanel/subscriptions/StoreSubscriptions";
import moment from "moment";

export default {
    namespaced: true,

    state: () => ({
        storeSubscriptions: [],
        storeSubscriptionInfo: {},
        updateSubscriptionDialog: false,
        updateAllSubscriptionsDialog: false,
        exportedFile: null,
    }),

    mutations: {
        setStoreSubscriptions(state, payload) {
            state.storeSubscriptions = payload;
        },
        setStoreSubscriptionInfo(state, payload) {
            state.storeSubscriptionInfo = payload;
            state.storeSubscriptionInfo.billings = payload?.billings?.map(b => {
                b.periodVal = moment(b.period.from).format("DD/MM/YYYY") + ' - ' + moment(b.period.to).format("DD/MM/YYYY") ;
                return b;
            });
        },
        setUpdateSubscriptionDialog(state, payload) {
            state.updateSubscriptionDialog = payload;
        },
        setUpdateAllSubscriptionsDialog(state, payload) {
            state.updateAllSubscriptionsDialog = payload;
        },
        setExportedFile(state, payload){
            state.exportedFile = payload
        },
    },

    actions: {
        async getStoreSubscriptions({ commit }, body){
            try {
                commit("setLoading", true, { root: true });
                const { data } = await StoreSubscriptions.get(body);
                
                const { store_subscriptions,pagination }  = data.data

                commit("setStoreSubscriptions", store_subscriptions);
                commit("setServerItemsLength", pagination.total, {
                    root: true
                });
                commit("setServerPagination", pagination, {
                    root: true
                });
                commit("setLoading", false, { root: true });
            } catch (ex) {
                commit("setLoading", false, { root: true });
            }
        },

        async getExportedFileStatus({ commit }) {
            try {
                const { data } = await StoreSubscriptions.getExportedFileStatus()
                
                commit("setExportedFile", data.data)
            } catch (ex) {
                console.log(ex)
                commit(
                    "setNotification",
                    {
                        show: true,
                        type: "error",
                        text: ex.response.data.message
                    },

                    { root: true }
                );
            }
        },

        async exportFile({ commit }, body ) {
            try {
                commit("setLoading", true, { root: true });
                const { data } = await StoreSubscriptions.exportFile(body) 
                
                commit("setExportedFile", data.data)

                commit("setLoading", false, { root: true });
            } catch (ex) {
                console.log(ex)
                commit("setLoading", false, { root: true });
                commit(
                    "setNotification",
                    {
                        show: true,
                        type: "error",
                        text: ex.response.data.message
                    },

                    { root: true }
                );
            }
        },
        
        async deleteExportedFile({ commit }, id) {
            try {
                commit("setLoading", true, { root: true });
                
                await StoreSubscriptions.deleteExportedFile(id)

                commit("setExportedFile", null)
                commit("setLoading", false, { root: true });
            } catch (ex) {
                commit("setLoading", false, { root: true });
                commit(
                    "setNotification",
                    {
                        show: true,
                        type: "error",
                        text: ex.response.data.message
                    },

                    { root: true }
                );
            }
        },
        
        async updateSettings({ commit }, payload) {
            try {
                commit("setLoading", true, { root: true });
                
                let {data} = await StoreSubscriptions.updateSettings(payload)

                commit("setLoading", false, { root: true });

                return data

            } catch (ex) {
                commit("setLoading", false, { root: true });
                commit(
                    "setNotification",
                    {
                        show: true,
                        type: "error",
                        text: ex?.response?.data?.message || "error"
                    },

                    { root: true }
                );
            }
        },
        
    }
        
};
